import { WarningPopup } from "./warningPopup";

export class LimitAgePopup extends WarningPopup {
  constructor(age: number, message: string) {
    super(message, require("/static/images/pictos_ages/age/enfants_" + age + ".png"));
  }
}
